<template>
	<b-card>
		<div class="hidden-print">
			<h4 class="mb-3"><i class="fa fa-list"></i> Balance Log Tahlili</h4>
			<b-row style="margin-top: 10px; margin-bottom: 10px">
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Asosiy Bo'lim:</label>
					<b-form-select v-model="departmentId">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
							:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null">-- Barchasi --</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Qaysi Bo'limdan (From Dep):</label>
					<b-form-select v-model="fromDepId">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
							:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null">-- Barchasi --</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Qaysi Bo'limga (To Dep):</label>
					<b-form-select v-model="toDepId">
						<option v-for="(selectOption, indexOpt) in departments" :key="indexOpt"
							:value="selectOption.id">{{ selectOption.name }}
						</option>
						<template slot="first">
							<option :value="null">-- Barchasi --</option>
						</template>
					</b-form-select>
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Kirim / Rasxod:</label>
					<b-form-select v-model="movementType">
						<option :value="null">-- Barchasi --</option>
						<option value="KIRIM">Faqat Kirim (Bo'lim hisobiga qo'shilganlar)</option>
						<option value="RASXOD">Faqat Rasxod (Bo'limdan kamayganlar)</option>
					</b-form-select>
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Tovar Kodi / Nomi:</label>
					<b-form-input v-model="itemCode" placeholder="Kod, artikul, shtrixkod..." />
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Hujjat №:</label>
					<b-form-input v-model="docNumber" placeholder="Hujjat yoki chek №..." />
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Hujjat Turi:</label>
					<b-form-select v-model="docType">
						<option :value="null">-- Barchasi --</option>
						<option value="NAKLADNOY">NAKLADNOY</option>
						<option value="PROTOKOL">PROTOKOL</option>
						<option value="SOTISH">SOTISH</option>
						<option value="ONE_TIME">ONE_TIME</option>
						<option value="AKT">AKT</option>
						<option value="EXAMINATION_OF_GOODS">EXAMINATION_OF_GOODS</option>
						<option value="EXPIRATION_AND_PRESENTATION">EXPIRATION_AND_PRESENTATION</option>
						<option value="PRODUCT_DEFECTS">PRODUCT_DEFECTS</option>
					</b-form-select>
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Harakat (Action):</label>
					<b-form-select v-model="action">
						<option :value="null">-- Barchasi --</option>
						<option value="KIRIM">KIRIM</option>
						<option value="SPISAT">SPISAT</option>
						<option value="SOTISH">SOTISH</option>
						<option value="DISCOUNT">DISCOUNT</option>
						<option value="KOCHIRISH">KOCHIRISH</option>
						<option value="QAYTARISH">QAYTARISH</option>
						<option value="CONVERSION_IN">CONVERSION_IN</option>
						<option value="CONVERSION_OUT">CONVERSION_OUT</option>
						<option value="SPISAT_IN">SPISAT_IN</option>
						<option value="SPISAT_OUT">SPISAT_OUT</option>
					</b-form-select>
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Boshlanish Sanasi:</label>
					<date-picker v-model="fromDate" lang="ru" style="width: 100%"
						placeholder="DD-MM-YYYY" valueType="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col md="3" sm="6" class="mb-2">
					<label class="small font-weight-bold">Tugash Sanasi:</label>
					<date-picker v-model="toDate" lang="ru" style="width: 100%"
						placeholder="DD-MM-YYYY" value-type="format" format="DD-MM-YYYY" />
				</b-col>
				<b-col md="3" sm="6" class="d-flex align-items-end mb-2">
					<b-button @click="getItems(1)" variant="primary" class="mr-2">
						<i class="fa fa-search"></i> Qidirish
					</b-button>
					<b-button @click="resetFilters" variant="secondary">
						<i class="fa fa-refresh"></i> Tozalash
					</b-button>
				</b-col>
			</b-row>
			<hr class="mt-2 mb-3">
		</div>

		<!-- Summary Cards (qtyAtStart, Incomes, Offs & Saldo) -->
		<b-row v-if="qtyAtStart || saldo || totals" class="mb-3">
			<b-col md="3" sm="6" v-if="qtyAtStart">
				<div style="min-height: 0 !important" class="card border-primary mb-2 shadow-sm">
					<div class="card-body p-3">
						<h6 class="card-title text-primary font-weight-bold mb-2">
							<i class="fa fa-calendar-check-o"></i> Qoldiq Boshida
						</h6>
						<div class="d-flex flex-column small">
							<span>Soni: <strong class="text-dark">{{ qtyAtStart.count || 0 }}</strong></span>
							<span>EUR: <strong class="text-dark">{{ formatMoney(qtyAtStart.sumEur) }} €</strong></span>
							<span>UZS: <strong class="text-dark">{{ formatMoney(qtyAtStart.sumUzs) }} UZS</strong></span>
						</div>
					</div>
				</div>
			</b-col>
			<b-col md="3" sm="6" v-if="totals">
				<div style="min-height: 0 !important" class="card border-success mb-2 shadow-sm">
					<div class="card-body p-3">
						<h6 class="card-title text-success font-weight-bold mb-2">
							<i class="fa fa-arrow-down"></i> Jami Kirimlar
						</h6>
						<div class="d-flex flex-column small">
							<span>Soni: <strong class="text-success">{{ totals.incomeQty || 0 }}</strong></span>
							<span>EUR: <strong class="text-dark">{{ formatMoney(totals.incomeSumEur) }} €</strong></span>
							<span>UZS: <strong class="text-dark">{{ formatMoney(totals.incomeSumUzs) }} UZS</strong></span>
						</div>
					</div>
				</div>
			</b-col>
			<b-col md="3" sm="6" v-if="totals">
				<div style="min-height: 0 !important" class="card border-danger mb-2 shadow-sm">
					<div class="card-body p-3">
						<h6 class="card-title text-danger font-weight-bold mb-2">
							<i class="fa fa-arrow-up"></i> Jami Rasxodlar
						</h6>
						<div class="d-flex flex-column small">
							<span>Soni: <strong class="text-danger">{{ totals.offsQty || 0 }}</strong></span>
							<span>EUR: <strong class="text-dark">{{ formatMoney(totals.offsSumEur) }} €</strong></span>
							<span>UZS: <strong class="text-dark">{{ formatMoney(totals.offsSumUzs) }} UZS</strong></span>
						</div>
					</div>
				</div>
			</b-col>
			<b-col md="3" sm="6" v-if="saldo">
				<div style="min-height: 0 !important" class="card border-info mb-2 shadow-sm">
					<div class="card-body p-3">
						<h6 class="card-title text-info font-weight-bold mb-2">
							<i class="fa fa-flag-checkered"></i> Saldo Oxirida
						</h6>
						<div class="d-flex flex-column small">
							<span>Soni: <strong class="text-dark">{{ saldo.count || 0 }}</strong></span>
							<span>EUR: <strong class="text-dark">{{ formatMoney(saldo.sumEur) }} €</strong></span>
							<span>UZS: <strong class="text-dark">{{ formatMoney(saldo.sumUzs) }} UZS</strong></span>
						</div>
					</div>
				</div>
			</b-col>
		</b-row>

		<!-- Loading state -->
		<div v-if="loading" class="text-center my-4">
			<b-spinner variant="primary" label="Yuklanmoqda..."></b-spinner>
		</div>

		<!-- Table -->
		<div v-else class="table-responsive">
			<table class="table table-bordered table-striped table-hover table-sm">
				<thead class="thead-dark">
					<tr>
						<th>ID</th>
						<th>Sana va Vaqt</th>
						<th>Bo'lim</th>
						<th>Qaysi Bo'limdan</th>
						<th>Qaysi Bo'limga</th>
						<th>Tovar Nomi</th>
						<th>Kodi</th>
						<th>Hujjat №</th>
						<th>Hujjat Turi</th>
						<th>Harakat</th>
						<th>Soni (Qty)</th>
						<th>Qoldiq (Remaining)</th>
						<th>Narxi (EUR)</th>
						<th>Summa (UZS)</th>
					</tr>
				</thead>
				<tbody>
					<tr v-for="item in items" :key="item.id">
						<td>{{ item.id }}</td>
						<td>{{ item.created }}</td>
						<td><strong>{{ item.department }}</strong></td>
						<td>{{ item.fromDepartment || '-' }}</td>
						<td>{{ item.toDepartment || '-' }}</td>
						<td>{{ item.itemName }}</td>
						<td><code>{{ item.itemCode }}</code></td>
						<td>{{ item.docNumber }}</td>
						<td><b-badge variant="info">{{ item.docType }}</b-badge></td>
						<td>
							<b-badge :variant="item.qty > 0 ? 'success' : 'danger'">
								{{ item.action }}
							</b-badge>
						</td>
						<td :class="item.qty > 0 ? 'text-success font-weight-bold' : 'text-danger font-weight-bold'">
							{{ item.qty }}
						</td>
						<td class="font-weight-bold">{{ item.remaining }}</td>
						<td>{{ item.price }}</td>
						<td>{{ formatMoney(item.sumUzs) }} UZS</td>
					</tr>
					<tr v-if="items.length === 0">
						<td colspan="14" class="text-center text-muted py-4">Ma'lumot topilmadi</td>
					</tr>
				</tbody>
				<tfoot v-if="totals && items.length > 0" class="thead-light">
					<tr class="font-weight-bold text-success">
						<td colspan="10" class="text-right">Jami Kirimlar:</td>
						<td>{{ totals.incomeQty || 0 }}</td>
						<td>-</td>
						<td>{{ formatMoney(totals.incomeSumEur) }} €</td>
						<td>{{ formatMoney(totals.incomeSumUzs) }} UZS</td>
					</tr>
					<tr class="font-weight-bold text-danger">
						<td colspan="10" class="text-right">Jami Rasxodlar:</td>
						<td>{{ totals.offsQty || 0 }}</td>
						<td>-</td>
						<td>{{ formatMoney(totals.offsSumEur) }} €</td>
						<td>{{ formatMoney(totals.offsSumUzs) }} UZS</td>
					</tr>
					<tr class="font-weight-bold text-primary">
						<td colspan="10" class="text-right">Net Harakat Jamisi:</td>
						<td>{{ totals.totalQty || 0 }}</td>
						<td>-</td>
						<td>{{ formatMoney(totals.totalSumEur) }} €</td>
						<td>{{ formatMoney(totals.totalSumUzs) }} UZS</td>
					</tr>
				</tfoot>
			</table>
		</div>

		<!-- Pagination -->
		<div v-if="total > 0" class="d-flex justify-content-between align-items-center mt-3">
			<div>Jami yozuvlar: <strong>{{ total }}</strong> ta</div>
			<b-pagination
				v-model="page"
				:total-rows="total"
				:per-page="size"
				@change="getItems"
				align="right"
				class="mb-0"
			></b-pagination>
		</div>
	</b-card>
</template>

<script>
import ReportService from './report.service';
import UsersService from '@/services/users.sevice';
import { TokenService } from '../../../services/storage.service';

export default {
	name: 'reportBalanceLog',
	data() {
		return {
			loading: false,
			departmentId: null,
			fromDepId: null,
			toDepId: null,
			movementType: null,
			itemCode: '',
			docNumber: '',
			docType: null,
			action: null,
			fromDate: null,
			toDate: null,
			departments: [],
			items: [],
			qtyAtStart: null,
			saldo: null,
			totals: null,
			page: 1,
			size: 50,
			total: 0
		};
	},
	async mounted() {
		await this.getDepartments();
	},
	methods: {
		async getDepartments() {
			await UsersService.getPermittedDepartments(TokenService.getCurrentUserId()).then(response => {
				this.departments = response.data.permittedDepartments
			})
		},
		formatMoney(val) {
			if (val == null) return '0.00';
			return Number(val).toLocaleString('ru-RU', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
		},
		async getItems(pageNo) {
			if (pageNo) this.page = pageNo;
			this.loading = true;

			const data = {
				departmentId: this.departmentId,
				fromDepId: this.fromDepId,
				toDepId: this.toDepId,
				movementType: this.movementType,
				itemCode: this.itemCode,
				docNumber: this.docNumber,
				docType: this.docType,
				action: this.action,
				startDate: this.fromDate || '',
				endDate: this.toDate || '',
				page: this.page,
				size: this.size
			};

			try {
				const res = await ReportService.getBalanceLogList(data);
				if (res && res.data) {
					this.items = res.data.data || [];
					this.total = res.data.total || 0;
					this.qtyAtStart = res.data.qtyAtStart || null;
					this.saldo = res.data.saldo || null;
					this.totals = res.data.totals || null;
				}
			} catch (e) {
				console.error(e);
			} finally {
				this.loading = false;
			}
		},
		resetFilters() {
			this.departmentId = null;
			this.fromDepId = null;
			this.toDepId = null;
			this.movementType = null;
			this.itemCode = '';
			this.docNumber = '';
			this.docType = null;
			this.action = null;
			this.fromDate = null;
			this.toDate = null;
			this.items = [];
			this.total = 0;
			this.page = 1;
			this.qtyAtStart = null;
			this.saldo = null;
			this.totals = null;
		}
	}
};
</script>